import { render, staticRenderFns } from "./ResearchHistory.vue?vue&type=template&id=56447bc8"
import script from "./ResearchHistory.vue?vue&type=script&lang=js"
export * from "./ResearchHistory.vue?vue&type=script&lang=js"
import style0 from "./ResearchHistory.vue?vue&type=style&index=0&id=56447bc8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports